<template>
  <div v-show="panelShow">
    <Col :xs="24" :sm="24" :md="24" :lg="colSpan" :style="{padding: '5px'}">
      <Card shadow style="height: 200px; max-height: 160px" class="home-card">
        <div slot="title"><font-awesome-icon icon="heartbeat" /><b> 告警概览</b></div>
        <Spin fix v-if="alarmCountLoading" class="home-component-loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>加载中</div>
        </Spin>
        <div>
          <Row>
            <Col :span="12">
              <div style="text-align: center;">
                <p>近7日告警总数</p>
                <div style="width: 200px; margin: 0 auto" v-if="!recent_get_status">
                  <Alert type="warning" show-icon>获取数据失败</Alert>
                </div>
                <div class="circle-alarm-outline circle-alarm-outline-seven-days-total" v-else>
                  <div class="circle-alarm circle-alarm-seven-days-total">
                    <span class="alarm-count-number"><count-to :end="recent_count" count-class="count-style" /></span>
                  </div>
                </div>
              </div>
            </Col>
            <Col :span="12">
              <div style="text-align: center">
                <p>正在告警</p>
                <div style="width: 200px; margin: 0 auto" v-if="!problem_get_status">
                  <Alert type="warning" show-icon>获取数据失败</Alert>
                </div>
                <Tooltip content="点击前往查看" placement="bottom-end" v-else>
                  <div class="circle-alarm-outline circle-alarm-outline-alarming">
                    <router-link :to="{ name: 'alarm_logs'}">
                      <div class="circle-alarm circle-alarm-alarming">
                        <span class="alarm-count-number"><count-to :end="problem_count" count-class="count-style" /></span>
                      </div>
                    </router-link>
                  </div>
                </Tooltip>
              </div>
            </Col>
          </Row>
        </div>
      </Card>
    </Col>
  </div>
</template>

<script>
import { getAlarmOverView } from '@/api/monitor'
import CountTo from '_c/count-to'

export default {
  name: 'alarm-count',
  components: {
    CountTo
  },
  props: {
    panelShow: {
      type: Boolean,
      default: true
    },
    colSpan: {
      type: Number,
      default: 8
    }
  },
  data () {
    return {
      recent_count: 0,
      recent_get_status: 1,
      problem_count: 0,
      problem_get_status: 1,
      alarmCountLoading: false
    }
  },
  watch: {
    panelShow () {
      if (this.panelShow) {
        this.getAlarmOver()
      }
    }
  },
  created: function () {
    if (this.panelShow) {
      this.getAlarmOver()
    }
  },
  methods: {
    getAlarmOver () {
      this.alarmCountLoading = true
      getAlarmOverView().then(res => {
        this.alarmCountLoading = false
        if (res.data.code === 200) {
          let recent = res.data.data.recent
          this.recent_count = recent.count
          this.recent_get_status = recent.status
          let problem = res.data.data.problem
          this.problem_count = problem.count
          this.problem_get_status = problem.status
        } else {
          this.recent_get_status = 0
          this.problem_get_status = 0
        }
      }).catch(errO => {
        this.alarmCountLoading = false
        this.recent_get_status = 0
        this.problem_get_status = 0
      })
    }
  }
}
</script>

<style scoped>
  .circle-alarm-outline {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    margin: 0 auto
  }
  .circle-alarm-outline-seven-days-total {
    border: 1px #2d8cf0 solid;
  }
  @-webkit-keyframes rotate{from{-webkit-transform: rotate(0deg)}
    to{-webkit-transform: rotate(359deg)}
  }
  @-moz-keyframes rotate{from{-moz-transform: rotate(0deg)}
    to{-moz-transform: rotate(359deg)}
  }
  @-o-keyframes rotate{from{-o-transform: rotate(0deg)}
    to{-o-transform: rotate(359deg)}
  }
  @keyframes rotate{from{transform: rotate(0deg)}
    to{transform: rotate(359deg)}
  }
  .circle-alarm-outline-alarming {
    border: 1px #ed4014 dashed;

    -webkit-transition-property: -webkit-transform;
    -webkit-transition-duration: 1s;
    -moz-transition-property: -moz-transform;
    -moz-transition-duration: 1s;
    -webkit-animation: rotate 30s linear infinite;
    -moz-animation: rotate 30s linear infinite;
    -o-animation: rotate 30s linear infinite;
    animation: rotate 30s linear infinite;
  }
  .circle-alarm {
    line-height: 70px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    margin: 4px
  }
  .circle-alarm-seven-days-total {
    background-color: #2d8cf0;
  }

  @-webkit-keyframes n_rotate{from{-webkit-transform: rotate(0deg)}
    to{-webkit-transform: rotate(-359deg)}
  }
  @-moz-keyframes n_rotate{from{-moz-transform: rotate(0deg)}
    to{-moz-transform: rotate(-359deg)}
  }
  @-o-keyframes n_rotate{from{-o-transform: rotate(0deg)}
    to{-o-transform: rotate(-359deg)}
  }
  @keyframes n_rotate{from{transform: rotate(0deg)}
    to{transform: rotate(-359deg)}
  }
  .circle-alarm-alarming {
    background-color: #ed4014;

    -webkit-transition-property: -webkit-transform;
    -webkit-transition-duration: 1s;
    -moz-transition-property: -moz-transform;
    -moz-transition-duration: 1s;
    -webkit-animation: n_rotate 30s linear infinite;
    -moz-animation: n_rotate 30s linear infinite;
    -o-animation: n_rotate 30s linear infinite;
    animation: n_rotate 30s linear infinite;
  }
  .alarm-count-number {
    color: #ffffff;
    font-size: 25px;
    line-height: 60px;
  }
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
